import React from "react";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";
import { TableCell, TableRow } from "@mui/material";
const PendingInvoiceList = ({ invoices }: any) => {
  const tableHeadings: TableHeading[] = [
    { label: "Inv. No.", align: "center" as const },
    { label: "Inv. Type", align: "center" as const },
    { label: "Invoice Value (£)", align: "center" as const },
    { label: "Status", align: "center" as const },
    { label: "Outstanding", align: "center" as const },
  ];

  return (
    <>
      <TableDesign
        tableHeadings={tableHeadings}
        tableHeadColor={"#fff"}
        cellColor={"#000"}
        pagination={null}
        stickyHeader={true}
        isLoader={false}
        filterOption={() => {}}
        setFilterOption={() => {}}
      >
        {invoices.length > 0 ? (
          invoices
            ?.filter((val: any) => val?.status?.toUpperCase() !== "PAID")
            ?.map((val: any, idx: number) => {
              return (
                <React.Fragment key={idx}>
                  <TableRow
                    // key={val?.client_id}
                    sx={{
                      fontWeight: 600,
                      // border: "1px solid #d1cfcf",
                      backgroundColor: idx % 2 === 0 ? "#F9F9F9" : "#FFFFFF",
                      "&:hover": {
                        backgroundColor: "#E5F4F1",
                        cursor: "pointer",
                      },
                    }}
                  >
                    <TableCell
                      align="center"
                      style={{ padding: "4px 0px", cursor: "pointer" }}
                    >
                      {val?.invoice_number}
                    </TableCell>
                    <TableCell align="center">{val?.invoice_type}</TableCell>
                    <TableCell align="center">{val?.total_amount}</TableCell>
                    <TableCell align="center">{val?.status}</TableCell>
                    <TableCell align="center">
                      {val?.outstanding_amount}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })
        ) : (
          <TableRow>
            <TableCell>
              <span style={{ position: "absolute" }}>Data Not Found!</span>
            </TableCell>
          </TableRow>
        )}
      </TableDesign>
    </>
  );
};

export default PendingInvoiceList;
